export const LanguagesList = [
  {
    language: 'English (US)',
    languageCode: 'en',
    countryCode: 'US'
  },
  {
    language: 'English (UK)',
    languageCode: 'en-GB',
    countryCode: 'GB'
  },
  {
    language: 'Português',
    languageCode: 'pt',
    countryCode: 'BR'
  },
  {
    language: 'Español',
    languageCode: 'es',
    countryCode: 'ES'
  }
];
export default LanguagesList;

export const LanguagesListEnglish = [
  {
    language: 'English (US)',
    languageCode: 'en',
    countryCode: 'US'
  },
  {
    language: 'English (UK)',
    languageCode: 'en-GB',
    countryCode: 'GB'
  },
  {
    language: 'Portuguese',
    languageCode: 'pt',
    countryCode: 'BR'
  },
  {
    language: 'Spanish',
    languageCode: 'es',
    countryCode: 'ES'
  }
];
